import "core-js/modules/es.array.concat.js";
import router from '@/router';
import store from '@/store';
import API from '@/api';
import { getUserId } from '@/utils/auth';
// import { Message } from 'element-ui';

function newPage(data) {
  window.open(decodeURIComponent("".concat(window.location.origin, "/?newPage=").concat(data.url, "&isHash=").concat(data.isHash, "&menuPath=").concat(window.encodeURIComponent(data.path))));
}
window.addEventListener('message', function (e) {
  var data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
  switch (data.type) {
    case 'LOGOUT':
      store.dispatch('user/logoutClear');
      router.push('/login?redirect=dashboard');
      break;
    // case "REFRESH_TOKEN":
    //     store.commit("user/SET_TOKEN",data.data.token)
    //     store.commit("user/SET_REFRESH_TOKEN",data.data.refreshToken)
    //     console.log("父页面接收到了",data)
    //   break;
    case 'newPage':
      // console.log('平台收到了新页面跳转！')
      newPage(data);
      break;
    case 'PLATFORM_JUMP':
      {
        var _data$data = data.data,
          url = _data$data.url,
          _data$data$jumpType = _data$data.jumpType,
          jumpType = _data$data$jumpType === void 0 ? 'routerJump' : _data$data$jumpType;
        if (jumpType === 'iframeJump') {
          store.dispatch('settings/changeSetting', {
            key: 'iframeUrl',
            value: url
          });
        } else {
          store.dispatch('settings/changeSetting', {
            key: 'iframeUrl',
            value: null
          });
          router.push(url);
        }
      }
      break;
    case 'REFRESH_MENU':
      API.getMenuInfo({
        userId: getUserId()
      }).then(function (res) {
        if (res.code === '0000000000') {
          store.dispatch('settings/changeSetting', {
            key: 'menuArr',
            value: res.result.resourceList
          });
        }
      }).catch(function () {});
      break;
    default:
      // do something if none of the cases match
      break;
  }
});